// import { useContext } from "react";
// import { EppoFeatureFlagContext } from "src/contexts/eppoFeatureFlag.context";
// import { AppCtx } from "src/contexts/app.context";
// import { useSession } from "next-auth/client";

// Force enable Mollie in all cases from now on. Not depending on a feature flag anymore.
// We keep the code in here for the foreseeable future in case we need to switch back to feature flag or Adyen all of a sudden.
// Return to false if we want to disable Mollie and enable Adyen as our PSP again.
export const usePspMollieEnabled = (): boolean => {
  return true;
  // const featureFlags = useContext(EppoFeatureFlagContext);
  // const { storeKey } = useContext(AppCtx);
  // const [session] = useSession();

  // const enableMolliePerStore = featureFlags.enableMolliePerStore
  //   ? featureFlags.enableMolliePerStore
  //   : false;

  // if (!enableMolliePerStore) {
  //   return false;
  // }

  // for (const [key, value] of Object.entries(enableMolliePerStore)) {
  //   if (
  //     key === "@otrium.com" &&
  //     session &&
  //     session.user &&
  //     session?.user?.email?.endsWith("@otrium.com")
  //   ) {
  //     // Enable it for all Otrium users, regardless of the store
  //     return value;
  //   }

  //   if (key === storeKey) {
  //     return value;
  //   }
  // }

  // return false;
};
